import React from "react";
import { ArrowRight } from "lucide-react";

const IMAGES = {
    dashboard:
        "https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/other/dashboard.jpg",
    myApplications:
        "https://storage.googleapis.com/accredian-assets/Frontend_Assests/Images/Accredian-react-site-images/other/MyApplications.jpg",
};

/**
 * variant: "dashboard" | "myApplications"
 */
const CONTENT = {
    dashboard: {
        heading: "You're not enrolled in any program yet.",
        description:
            "Explore our executive programs built for working professionals looking to upskill, pivot, or accelerate their careers.",
        ctaLabel: "Explore Programs",
        ctaHref: "https://accredian.com/programs",
    },
    myApplications: {
        heading: "No applications in progress.",
        description:
            "Ready to take the next step? Choose a program that aligns with your goals and begin your application journey.",
        ctaLabel: "Choose a Program",
        ctaHref: "https://accredian.com/programs",
    },
};

const NoEnrollmentsState = ({ variant = "dashboard" }) => {
    const imageSrc = IMAGES[variant] ?? IMAGES.dashboard;
    const content = CONTENT[variant] ?? CONTENT.dashboard;

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] p-8 text-center animate-in fade-in zoom-in duration-500">
            <div className="mb-6">
                <img
                    src={imageSrc}
                    alt={
                        variant === "myApplications"
                            ? "No applications yet"
                            : "No enrollments yet"
                    }
                    className="mx-auto w-64 md:w-80 object-contain drop-shadow-md"
                    onError={(e) => {
                        // hide broken image gracefully
                        e.currentTarget.style.display = "none";
                    }}
                />
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 tracking-tight">
                {content.heading}
            </h2>

            <p className="text-gray-600 max-w-md mb-8 text-base md:text-lg leading-relaxed">
                {content.description}
            </p>

            <a
                href={content.ctaHref}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center justify-center px-8 py-3 font-semibold text-white transition-all duration-200 bg-blue-600 rounded-full hover:bg-blue-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
            >
                <span className="mr-2">{content.ctaLabel}</span>
                <ArrowRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1" />
            </a>
        </div>
    );
};

export default NoEnrollmentsState;
